import React, { useEffect } from "react";
import "./style.less";
import { Grid, Icon } from "semantic-ui-react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchAvailableCities } from "../../../redux/geofence/actions";
import { Link } from "react-router-dom";
import bangalore from "../../../icons/bangalore-icon.png";
import delhi from "../../../icons/delhi-icon.png";
import chennai from "../../../icons/chennai-icon.png";
import gurgaon from "../../../icons/gurgaon-icon.png";
import hyderabad from "../../../icons/hyderabad-icon.png";
import mumbai from "../../../icons/mumbai-icon.png";
import noida from "../../../icons/noida-icon.png";
import pune from "../../../icons/pune-icon.png";

const cityNameToImg = {
  Bangalore: bangalore,
  Delhi: delhi,
  Chennai: chennai,
  Gurgaon: gurgaon,
  Hyderabad: hyderabad,
  Mumbai: mumbai,
  Noida: noida,
  Pune: pune
};

function CitySelectorPage() {
  const dispatch = useDispatch();
  const availableCities = useSelector(
    ({ geofence }) => geofence.availableCities,
    shallowEqual
  );
  useEffect(() => {
    if (availableCities === null) {
      dispatch(fetchAvailableCities());
    }
  }, [availableCities, dispatch]);
  const gridColumns = Math.min(5);
  return (
    <div className="CitySelectorPage">
      <h1>Choose City</h1>
      <br />
      <br />
      <Grid stackable columns={gridColumns}>
        {availableCities &&
          availableCities.map(e => {
            return (
              <Grid.Column key={e}>
                <Link to={`/city/${e}/geofences/`}>
                  <div key={e} className="CityContainer">
                    <div className="CityTile">
                      <div className="CityAvatar">
                        {cityNameToImg[e] ? (
                          <img alt={`${e}`} src={cityNameToImg[e]} />
                        ) : (
                          <div className="CityInitials">
                            {`${e.charAt(0)}${e.charAt(1)}`.toUpperCase()}
                          </div>
                        )}
                      </div>
                    </div>
                    <span>{e}</span>
                  </div>
                </Link>
              </Grid.Column>
            );
          })}
        <Grid.Column>
          <Link to="/city/create">
            <div className="CityCreateCta">
              <div>
                <Icon name="add" />
              </div>
            </div>
          </Link>
        </Grid.Column>
      </Grid>
    </div>
  );
}

CitySelectorPage.defaultProps = {};

CitySelectorPage.propTypes = {};

export default CitySelectorPage;
